export class UserProfileFlagStore {
    private static _instance: UserProfileFlagStore = new UserProfileFlagStore();
    canActivateUserProfile: 'true' | 'false' = null;
    MAX_PREVIEW_FILE_SIZE: MaxPreviewSize = null;
  
    private constructor() {
      if (UserProfileFlagStore._instance) {
        return UserProfileFlagStore._instance;
      }
      UserProfileFlagStore._instance = this;
    }
  
  
  
    public static getInstance(): UserProfileFlagStore {
      return UserProfileFlagStore._instance;
    }
  }

  export interface MaxPreviewSize {
    [key: string]: {contentType: string, maxSize: string}
  }